
<style lang="scss" scoped>
.app-sidebar {
  width: $side_bar_width;
  height: 100%;
  position: absolute;
  padding-top: 16px;
  box-sizing: border-box;
  left: 0;
  background-color: $bg-color-dark;
}
</style>
<style lang="scss">
.app-sidebar .el-menu {
  padding-right: 5px !important;
  border-right: none;
  background-color: $bg-color-dark;
}

.app-sidebar .el-menu-item,
.app-sidebar .el-submenu__title {
  height: 48px !important;
  line-height: 48px !important;
  padding-left: 30px !important;
  margin-bottom: 8px;
  min-width: 140px !important;
  color: $text-white;
  background-color: $bg-color-dark;

  i.azappfont {
    color: $text-white !important;
  }
}

.app-sidebar .el-menu-item {
  transition: border-radius 0s;
  position: relative;
  background-color: $bg-color-dark !important;
  // color: $text-white-active !important;

  s.lft-line {
    position: absolute;
    left: 0;
    top: 0;
    width: 4px;
    height: 100%;
    background-color: transparent;
  }
}

.app-sidebar .item-is-active,
.app-sidebar .el-menu-item:active {
  color: $text-white-active !important;
  background-color: $bg-color-dark-second !important;
  border-radius: 0 24px 24px 0;

  i.azappfont {
    color: $text-white-active !important;
  }

  s.lft-line {
    background-color: $color-primary;
  }
}

.app-sidebar .el-menu-item:not(.item-is-active):hover {
  color: $text-white-active !important;
  background-color: $bg-color-dark !important;

  i.azappfont {
    color: $text-white-active !important;
  }
}

.app-sidebar .el-menu-item:not(.item-is-active):active {
  background-color: $bg-color-dark !important;
}

.app-sidebar .el-menu-item span,
.app-sidebar .el-submenu__title span {
  padding-left: 10px !important;
}
// 拥有子导航的样式
.el-submenu__title:hover {
  background-color: $bg-color-dark-second !important;
}

.app-sidebar .father-is-active {
  .el-submenu__title {
    background-color: $bg-color-dark-second;
  }
}

.app-sidebar .is-opened {
  background-color: $bg-color-dark-second;

  i.azappfont {
    font-size: 12px;
  }

  .el-submenu__title:hover {
    background-color: $bg-color-dark-second;
  }

  .el-menu {
    background-color: $bg-color-dark-second;
  }

  .el-menu-item {
    background-color: $bg-color-dark-second !important;
  }

  .el-menu-item:hover {
    background-color: #171718 !important;
  }

  .item-is-active {
    background-color: #171718 !important;
  }
}

.app-sidebar .el-submenu__title i.el-submenu__icon-arrow {
  right: 10px;
}

.global-panel {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  cursor: pointer;

  .help-center-bar {
    margin: 0;
    line-height: 26px;
    display: inline-block;
    width: 100%;
    padding-left: 10px;
    box-sizing: border-box;
    background: #0c0b0b;
    color: #9c9fa6;
    text-align: left;
    user-select: none;

    &:hover {
      opacity: 0.6;
      text-decoration: underline;
    }

    &:active {
      opacity: 1;
    }
  }
}

.switch-user {
  line-height: 26px;
  display: inline-block;
  width: 100%;
  padding-left: 10px;
  box-sizing: border-box;
  background: #0c0b0b;
  margin-bottom: 2px;
  color: #9c9fa6;

  i {
    font-size: 16px;
    color: #9c9fa6;
  }

  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }
}
</style>
<template>
  <div class="app-sidebar">
    <el-menu
      class="el-menu-vertical-demo"
      :default-active="defaultActive($route.path)">
      <template v-for="item in navList">
        <router-link v-if="!item.children" :to="item.path" :key="item.path">
          <el-menu-item :index="item.path"
            :class="{'item-is-active': curPath.indexOf(item.path) === 0}">
            <s class="lft-line"></s>
            <i v-if="item.icon"
              class="azappfont"
              :class="item.icon"></i>
            <span slot="title">{{item.name}}</span>
          </el-menu-item>
        </router-link>
        <el-submenu v-else-if="item.children.length > 0" :index="item.path"
          :key="item.path"
          :class="{'father-is-active':curPath.indexOf(item.path) === 0}">
          <template slot="title">
            <s class="lft-line"></s>
            <i v-if="item.icon"
              class="azappfont"
              :class="item.icon"></i>
            <span>{{item.name}}</span>
          </template>
          <template v-for="child in item.children">
            <router-link :to="child.path" :key="child.path">
              <el-menu-item :index="child.path" :key="child.path"
                :class="{'item-is-active': curPath.indexOf(child.path) === 0}">
                <s class="lft-line"></s>
                <i class="azappfont az-app-arrows-go"></i>
                <span>{{child.name}}</span>
              </el-menu-item>
            </router-link>
          </template>
        </el-submenu>
      </template>
    </el-menu>
    <div class="global-panel">
      <span v-if="is_super === 1" class="switch-user" @click="switchUser">
        切换用户 >
      </span>
      <span class="help-center-bar" @click="goHelpCenter">点击进入帮助中心 ></span>
    </div>
    <switch-user-dialog ref="swidthUserDialog"></switch-user-dialog>
  </div>
</template>
<script>
/* @flow */
import navConfig from '../navConfig/index';
import { mapGetters } from 'vuex';
import switchUserDialog from './switchUserDialog.vue'

/**
 * 筛选异步路由
 */
function filterAsyncRouter(
  navConfig: Array<Object>,
  permission: Array<string> = []
): Array<Object> {
  return navConfig.filter(navItem => {
    if (!hasPermission(permission, navItem)) return false;
    if (navItem.children && navItem.children.length > 0) {
      navItem.children = filterAsyncRouter(navItem.children, permission);
    }
    return true;
  });
}

/**
 * 判断路由权限
 */
function hasPermission(
  permission: Array<string> = [],
  navItem: Object
): boolean {
  if (!navItem.sign) return true;
  return permission.indexOf(navItem.sign) >= 0;
}

export default {
  components: { switchUserDialog },
  name: 'appSidebar',
  data() {
    return {
      bgColorSidebar: this.GetCssConstGlobal('bg-color-sidebar')
    }
  },
  methods: {
    defaultActive(routePath: string): string {
      const pathList: Array<string> = routePath.split('/');
      if (pathList.length > 2) routePath = `/${pathList[1]}/${pathList[2]}`;
      return routePath;
    },

    goHelpCenter() {
      console.log('1111')
      window.open('/page/help_center')
    },

    switchUser() {
      this.$refs['swidthUserDialog'].$emit('open')
    }
  },
  computed: {
    ...mapGetters([
      'permission',
      'is_super'
    ]),
    curPath() {
      return this.$route.path;
    },
    navList() {
      return filterAsyncRouter(navConfig, this.permission);
    }
  }
};
</script>
